import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=233e385e&"
import script from "./SettingsPanel.vue?vue&type=script&lang=ts&"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports